import { useEffect } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import { obtenerNoticiasCurso } from '../../../store/slices/noticia/thunks';
import { startLoadingNoticia } from '../../../store/slices/noticia';
import Latex from 'react-latex-next';

const Noticias = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { noticias, isLoading } = useSelector((state: RootState) => state.noticia);
    const { curso } = useSelector((state: RootState) => state.curso);

    useEffect(() => {
        if (curso?.cid) {
            dispatch(obtenerNoticiasCurso(curso.cid));
            dispatch(startLoadingNoticia());
        }
    }, [curso, dispatch])

    if (isLoading) {
        return (
            <>
                <h2>Noticias</h2>

                <div className="d-flex justify-content-center my-5">
                    <div className="spinner-border" role="status" style={{ color: '#3b5998' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <h2>Noticias</h2>

            {
                noticias.map(item => {
                    const { id, fecha, titulo, contenido } = item

                    let date = new Date(fecha)
                    let day = date.getDate()
                    let month = date.toLocaleString('es-US', {
                        month: 'long',
                    });
                    let year = date.getFullYear()

                    return (
                        <div key={id}>
                            <hr style={{ backgroundColor: '#3b5998' }} className='mt-5' />

                            <span
                                style={{ backgroundColor: '#3b5998' }}
                                className="badge"
                            >
                                {day} de {month} de {year}
                            </span>

                            <h4 className='my-3'>{titulo}</h4>

                            <Latex>{contenido}</Latex>
                        </div>
                    )
                })
            }
        </>
    )
}

export default Noticias;